const lsv = 'v7' // local storage version
export const QUIZ_INDEX = `might-could-style-quiz-index-data-${lsv}`
export const ART_STYLE_DATA = `might-could-art-style-data-${lsv}`
export const QUIZ_ANSWERS = `might-could-style-quiz-answers-data-${lsv}`

// localStorage.clear();
export const getLocalStorageItem = (key: string): any => {
  const raw_value = localStorage.getItem(key)
  let return_value = undefined
  try {
    if (raw_value === 'undefined' || raw_value === null) {
      return_value = undefined
    } else {
      return_value = JSON.parse(raw_value)
    }
  } catch (e) {
    console.warn(e)
    console.warn(return_value)
  }
  // console.log(`Returning ${JSON.stringify(return_value)} for ${key}`)
  return return_value
}

export const setLocalStorageItem = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value))
}
